import { genCode } from '../../core/selectors.js';
import { S, save } from '../../core/store.js';
import { $ } from '../../core/util.js';
import { vAdmin } from './view.js';
import { actions, changes } from './actions.js';

// Payment and settings fields share one change handler each: data-chg="bank-<field>"
const NUMERIC = ['terms', 'goal', 'lateFee', 'lateDays'];
const bank = {};
['bankName', 'bsb', 'acc', 'terms', 'goal', 'lateFee', 'lateDays'].forEach((f) => {
  bank['bank-' + f] = (el) => { S.settings[f] = NUMERIC.includes(f) ? Number(el.value) || 0 : el.value.trim(); save(); };
});

export default {
  id: 'admin', label: 'Admin', icon: 'admin', nav: true,
  show: (u) => u.role === 'admin',
  view: vAdmin, actions,
  changes: { ...changes, ...bank },
  inputs: { clcode(t) { const c = $('#cl-code'); if (c) c.placeholder = t.value ? genCode(t.value) : 'Auto'; } }
};
